import { render, staticRenderFns } from "./huozhu.vue?vue&type=template&id=c1b416dc&scoped=true&"
import script from "./huozhu.vue?vue&type=script&lang=js&"
export * from "./huozhu.vue?vue&type=script&lang=js&"
import style0 from "./huozhu.vue?vue&type=style&index=0&id=c1b416dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b416dc",
  null
  
)

export default component.exports